// extracted by mini-css-extract-plugin
module.exports = {"searchHeader":"fixed-shift_searchHeader_2q96S","tipText":"fixed-shift_tipText_C_FAE","operation":"fixed-shift_operation_B2rr2","states":"fixed-shift_states_2R2_C"};